// Pipeline Health — answers "is my data fresh and trustworthy?"
import { useInfoModal, PageChrome, InfoModal, dqBadgeFor } from './Chrome.jsx';
import { pipelineHealth, SUB_PAGES } from './helpers.js';
import { ActivityFeed, PipelineCard } from './Widgets.jsx';

export function PagePipeline({ stats, nav }) {
  const info = useInfoModal();
  const helpEntry = SUB_PAGES.find((p) => p.id === 'pipeline');
  const buckets = pipelineHealth(stats.freshness || []);
  const healthy = buckets.filter((b) => b.status === 'completed').length;
  const failed = buckets.filter((b) => b.status === 'failed').length;
  const subtitle = failed > 0
    ? `${failed} pipeline${failed === 1 ? '' : 's'} FAILED — investigate before trusting numbers elsewhere.`
    : `${healthy} of ${buckets.length} pipelines reporting healthy.`;

  return (
    <>
      <PageChrome
        title="Pipeline Health"
        subtitle={subtitle}
        onHome={() => nav.goSubPage('overview')}
        onBack={nav.goBack} canBack={nav.canBack}
        onInfo={info.onOpen}
        dqBadge={dqBadgeFor(stats, () => nav.goSubPage('data_quality'))}
      />

      <div className="db-card">
        <div className="db-card-title">Upstream pipelines</div>
        <div className="db-card-sub">
          Latest run of each logical pipeline that feeds the dashboard. Failures or stale runs (&gt;30h) mean
          the numbers downstream may be incorrect.
        </div>
        <div className="db-pipe-grid">
          {buckets.map((b) => <PipelineCard key={b.id} item={b} />)}
        </div>
      </div>

      <div className="db-card">
        <div className="db-card-title">Recent activity</div>
        <div className="db-card-sub">Last 12 extraction batches across all pipelines.</div>
        <ActivityFeed rows={stats.recent_activity || []} />
      </div>

      <div className="db-card">
        <div className="db-card-title">Run a pipeline manually</div>
        <div className="db-card-sub">
          Use the Data Extraction tab to trigger Dayforce extract, NetSuite sync, or billing reprocess on demand.
        </div>
        <button type="button" className="btn btn-primary" onClick={() => nav.goExtraction()}>
          Open Data Extraction →
        </button>
      </div>

      <InfoModal open={info.open} onClose={info.onClose} title="About Pipeline Health" body={helpEntry?.help} />
    </>
  );
}
